import { GameAccount, GameAssetType, UgcAsset } from '@/types';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const ugc = {
  getGameAccounts: async (gameId: number) => {
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse<GameAccount[]>>(
      '/api/v1/ugc/game/accounts',
      {
        params: { gameId },
      },
    );
    return data;
  },
  getAssetsByRoleId: async (params: {
    cursor?: string;
    gameId: number;
    type: GameAssetType;
    page?: number;
    pageSize: number;
    roleId: string;
    currentParentTaskId: number;
  }) => {
    const { data } = await FastApiAxiosInstance.get<
      any,
      ExtendAxioResponse<{
        items: UgcAsset[];
        nextCursor: string;
      }>
    >('/api/v1/ugc/game/works', {
      params,
    });
    return data;
  },
  saveGameWork: async (params: { currentTaskId: number; workId: string; gameId: number; workType: GameAssetType }) => {
    return await FastApiAxiosInstance.post('/api/v1/ugc/game/works/commit', params);
  },
};
export default ugc;
